import { useMutation } from "react-query";
import api from "../../client";
import {
  CreateRepresentativePayload,
  RepresentativeDetailResponseData,
} from "../../types/representative";

const postData = async (
  payload: CreateRepresentativePayload,
): Promise<RepresentativeDetailResponseData> => {
  const { data } = await api.post<RepresentativeDetailResponseData>(
    `/representatives`,
    payload,
  );

  return data;
};

export const useCreateRepresentative = () => {
  return useMutation((payload: CreateRepresentativePayload) => {
    return postData(payload);
  });
};
